import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 14222 14222" {...props}>
    <title>ikeetmee.nl on Facebook</title>
    <path
      d="M14222 7111c0,-3927 -3184,-7111 -7111,-7111 -3927,0 -7111,3184 -7111,7111 0,3549 2600,6491 6000,7025l0 -4969 -1806 0 0 -2056 1806 0 0 -1567c0,-1782 1062,-2767 2686,-2767 778,0 1592,139 1592,139l0 1750 -897 0c-883,0 -1159,548 -1159,1111l0 1334 1972 0 -315 2056 -1657 0 0 4969c3400,-533 6000,-3475 6000,-7025z"
      stroke="none"
    />
  </Icon>
);
